module.exports = __webpack_public_path__ + "img/crm_invalid_data.b51871c5.png";